"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV2DashboardGet = void 0;
exports.v2DashboardGetSetMock = v2DashboardGetSetMock;
exports.v2DashboardGet = v2DashboardGet;
exports.useQueryV2DashboardGet = useQueryV2DashboardGet;
exports.useInfiniteQueryV2DashboardGet = useInfiniteQueryV2DashboardGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v2DashboardGetSetMock(mock) {
    setMock = mock;
}
async function v2DashboardGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v2/dashboard/equipment/${params.softwareNumber}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.equipmentType = params.equipmentType;
    queryParams.platform = params.platform;
    queryParams.date = params.date;
    queryParams.userType = params.userType;
    queryParams.isClub = params.isClub;
    queryParams.isEmbedded = params.isEmbedded;
    queryParams.doEnableScaling = params.doEnableScaling;
    queryParams.useMetricUnits = params.useMetricUnits;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV2DashboardGet = 'wolf-dashboard-service:v2DashboardGet:get';
function useQueryV2DashboardGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2DashboardGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV2DashboardGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2DashboardGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v2DashboardGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v2-dashboard-get.js.map